export default __webpack_public_path__ + "static/media/Contato.13b753e8.svg";